import React from 'react';
import { useRecoilState } from 'recoil';
import { Checkbox } from 'fronton-react';
import { getIsCheckedProducts } from 'common/helpers/get-is-checked-products.helper';
import { savedConfigurationCalculationState } from '../../../../store/calculation';
import { CheckboxContainer } from './styles';

type TCheckboxComponent = {
  productId: string;
};

export const CheckboxComponent = ({ productId }: TCheckboxComponent) => {
  const [savedConfigurationCalculation, setSavedConfigurationCalculation] = useRecoilState(
    savedConfigurationCalculationState
  );

  const isChecked =
    getIsCheckedProducts({ checkedProducts: savedConfigurationCalculation.checkedProducts, productId }) ??
    false;

  const handleCheckboxChange = () => {
    setSavedConfigurationCalculation(prevState => ({
      ...prevState,
      checkedProducts: prevState.checkedProducts.map(card =>
        card.id === productId ? { ...card, isChecked: !card.isChecked } : card
      ),
    }));
  };

  return (
    <CheckboxContainer>
      <Checkbox checked={isChecked} onChange={handleCheckboxChange} />
    </CheckboxContainer>
  );
};
